import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import { appContext } from '../AarmaContext';
import axios from 'axios';


export default function Preesale() {
    const { account, stakcontract, settings, connectWallet, library, esigner, toastSuccess, toastError, copyaddress, ethers, formatAddress, contdata, switchNetwork } = useContext(appContext);
    const [tokenchoice, settokenchoice] = useState(0);
    const [usdt, setusdt] = useState(0);
    const [token, settoken] = useState(0);
    const [trdone, settrdone] = useState(false);
    const [hash, sethash] = useState("");
    const [tokennew, settokennew] = useState(0);
    const [default_ref, setDefaultref] = useState("");
    const [showReferral, setShowReferral] = useState(false);
    const [referral, setReferral] = useState("");
    const [referralFound, setReferralFound] = useState('');
    const [data, setdata] = useState([]);
    const navigate = useNavigate();

    const handleChange = (event) => {
        const value = event.target.value;
        settokennew(value);
        console.log("DEfa", default_ref);
        // Check if the entered value is 100 or greater
        if (value >= 100) {
            if (referralFound) {
                setReferral(referralFound)
            } else {
                setReferral("");
                setShowReferral(true);
            }
        } else {
            setShowReferral(false);
        }
    };

    const getData = async () => {
        try {
            const response = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "transaction",
                submethod: "getbyid",
                address: account,
                // page: currentPage,
                // pageSize: pageSize,
                key: process.env.REACT_APP_KEY,
            });

            if (response.data.error) {
                // Handle error response from the backend if needed
                return;
            }

            // Assuming the response includes referral information
            const referralExists = response.data.data[1].referral_address; // Adjust this according to your actual response structure

            // Handle referral logic based on referralExists value
            if (referralExists) {
                console.log("Referral already added for this user", referralExists);
                // Handle logic for when referral is already added
                setShowReferral(false);
            } else {
                console.log("No referral added for this user yet");
                // Handle logic for when referral is not added yet
                setShowReferral(true);
            }

            // Set data and pages as before
            setdata(response.data.data);
            console.log("setdata", data);
            //   setPages(Math.ceil(response.data.dataLength / pageSize));
        } catch (error) {
            console.error("Error fetching data:", error);
            // Handle error from Axios or other errors
        }
    };

    const checkForReff = async () => {
        try {
            await axios
                .post(process.env.REACT_APP_BACKEND_LINK, {
                    method: "referralreward",
                    submethod: "checkforrefadd",
                    address: account,
                    key: process.env.REACT_APP_KEY,
                })
                .then((res) => {
                    // var dedata = decryptData(res.data);

                    if (res.data.error) {
                        return "";
                    }
                    if (res?.data?.data?.length && res?.data?.data[0]?.address) {
                        setReferralFound(res?.data?.data[0]?.referral_address);
                    } else {
                        setReferralFound("");
                    }

                });
        } catch (err) {
            console.log("error in checkForReff : ", err)
            setReferralFound("");
        }
    }

    useEffect(() => {
        if (account) {
            checkForReff();
            setDefaultref(process.env.REACT_APP_DEFAULT_REFERRAL);
            console.log("ADFASDF", checkForReff());
        }
    }, [account])


    const onDeposit = async () => {

        sethash(null)
        settrdone(true);
        sethash("");
        // switchNetwork(80002);

        try {
            // Call your switchNetwork function to change the network
            await switchNetwork(80002);
            window.location.reload();
        } catch (error) {
            // Handle any errors that occur during network switching
            console.error('Error switching network:', error);
            toastError("Network switch failed");
            settrdone(false);
            return;
        }

        if (!account) {
            connectWallet();
            toastError("Connect first");
            settrdone(false);
            return;
        }

        if (tokennew === 0) {
            toastError("Enter Amount");
            settrdone(false);
            return;
        }
        // if(!referral){
        //     setReferral(default_ref);
        // }

        if (referral?.toLowerCase() === account?.toLowerCase()) {
            toastError("add other refferal");
            settrdone(false);
            return;
        }

        // if (tokennew < 100) {
        //     toastError("add other refferal");
        //     settrdone(false);
        //     return;
        // }

        let contract = new library.Contract(
            settings.contract,
            JSON.parse(settings.contract_abi),
            esigner
        );
        let usdt_contract = new library.Contract(
            settings.usdt,
            JSON.parse(settings.usdt_abi),
            esigner
        );
        let token_contract = new library.Contract(
            settings.token,
            JSON.parse(settings.token_abi),
            esigner
        );
        const allowance = await token_contract.allowance(
            account,
            settings.contract
        );

        const usdtallowance = await usdt_contract.allowance(
            account,
            settings.contract
        );

        async function main() {
            // var gsl = await stakcontract//   .stake(ethers.utils.parseEther(`${amount}`), incappass, referral)
            //   .estimateGas( { from: account, value: `${Number(calcstakingfee) + 1000000000}` });
            //   console.log("gasghd ",gsl,await library.eth.getGasPrice()
            //   );
            try {
                var stk = null
                console.log("ADSFA", ethers.utils.parseEther(`${usdt}`), referral ? referral : default_ref);
                if (tokenchoice === 0) {
                    stk = await contract.buyTokensUsdt(
                        ethers.utils.parseEther(`${usdt}`), referral ? referral : default_ref
                    );
                } else {
                    stk = await contract.buyTokens(
                        ethers.utils.parseEther(`${token}`), referral ? referral : default_ref
                    );
                }
                const receipt = await stk.wait();
                sethash(receipt.transactionHash);
                toastSuccess("Transaction done");
                toastSuccess("You will receive AARMA within 5 minute");
                await axios
                    .post(process.env.REACT_APP_BACKEND_LINK, {
                        method: "transaction",
                        submethod: "insert",
                        key: process.env.REACT_APP_KEY,
                        address: account,
                        hash: receipt.transactionHash,
                        amount: usdt,
                        token: token,
                        sent_token: tokennew,
                        isarma: tokenchoice === 1,
                        phase: contdata.current_phase + 1,
                        rate: contdata.current_price,
                        referral_address: referral ? referral.toLowerCase() : default_ref.toLowerCase(),
                        referral_reward: referral ? tokennew * 0.03 : 0,
                    })
                    .then((res) => {
                        settoken(0)
                        settokennew(0)
                        setusdt(0)
                        // var dedata = decryptData(res.data);
                        checkForReff();
                        setReferral("");
                        setShowReferral(false);
                        settokennew(0)
                        if (res.data.error) {
                            return "";
                        }
                    });
                // sethash(randomHash);

                settrdone(false);
                navigate("/dashboard");

            } catch (error) {
                toastError("Transaction declined");
                console.log("EDDD", error);
                settrdone(false);
                return;
            }
        }

        // if (Number(library.utils.fromWei(allowance, "ether")) < total_tokens) {
        var tallo = 0
        var talloToken = 0
        if (tokenchoice === 0) {
            tallo = usdtallowance
            talloToken = usdt
        } else {
            tallo = allowance
            talloToken = token
        }
        if (Number(ethers.utils.formatEther(tallo)) < talloToken) {
            // if (false) {
            try {
                var approv = null
                if (tokenchoice === 0) {
                    approv = await usdt_contract.approve(
                        settings.contract,
                        ethers.utils.parseEther("100000000")
                    );
                } else {
                    approv = await token_contract.approve(
                        settings.contract,
                        ethers.utils.parseEther("100000000")
                    );
                }
                const receipt = await approv.wait();
                console.log(receipt);
                toastSuccess("Token Approved");
                main();
            } catch (error) {
                console.log("error", error);
                toastError("Token not approved");
                settrdone(false);
                return;
            }
        } else {
            main();
        }
    };
    // useEffect(() => {
    //     if (contdata === null) {
    //         return
    //     }
    //     settokennew(Number(usdt / contdata.current_price).toFixed(4))
    // }, [usdt, contdata])
    const getSmc = async () => {
        var tokendep = await stakcontract.convertTokenToUSDT(ethers.utils.parseEther(`${1}`))
        var rated = Number(ethers.utils.formatUnits(tokendep, 18))
        // var rated = 0.00726

        settoken(Number(Number(tokennew * contdata.current_price) / rated).toFixed(4))

    }
    // useEffect(() => {
    //     if (stakcontract === null) {
    //         return
    //     }
    //     // 
    // }, [token, stakcontract])

    useEffect(() => {
        if (contdata === null) {
            return
        }
        console.log("Number(tokennew / contdata.current_price)", Number(tokennew), contdata.current_price);
        if (tokenchoice === 0) {
            settoken(0)
            setusdt(Number(tokennew * contdata.current_price).toFixed(4))
        } else {
            setusdt(0)
            getSmc();
            getData();
        }
    }, [account, tokenchoice, tokennew, contdata])
    return (
        <>
            <section className="earn_crypto pt-120 pb-120" id='Preesale'>
                <div className="container">
                    <div className="row gy-5 gy-md-6 d-flex justify-content-center align-items-center">
                        <div className="col-xl-6 col-lg-6 col-md-8  col-sm-12">
                            <div className="earn_crypto__card one bg7-color br2 rounded-4 p-6 p-md-8 h-100 wow fadeInUp">
                                <div className="d-flex align-items-start justify-content-center flex-wrap gap-3 mb-8 mb-sm-10 mb-md-5">
                                    <div className='text-center'>
                                        <h2 className="mb-3">Arma Presale</h2>
                                        <span>Phase - {contdata !== null ? contdata.current_phase + 1 : 0} Rate : ${contdata !== null ? contdata.current_price : 0}</span>
                                    </div>
                                </div>
                                <ProgressBar
                                    percent={contdata !== null ? contdata.sold_per : 0}
                                    filledBackground="linear-gradient(to right, #fefb72, #f0bb31)"
                                >
                                    <Step transition="scale">
                                        {({ accomplished }) => (
                                            <span
                                                className="progress_bar_circle"
                                                style={{
                                                    filter: `grayscale(${accomplished ? 0 : 80}%)`,
                                                }}
                                            ></span>
                                        )}
                                    </Step>
                                    <Step transition="scale">
                                        {({ accomplished }) => (
                                            <span
                                                className="progress_bar_circle"
                                                style={{
                                                    filter: `grayscale(${accomplished ? 0 : 80}%)`,
                                                }}
                                            ></span>
                                        )}
                                    </Step>
                                </ProgressBar>
                                <div className="d-flex justify-content-between my-1">
                                    <span>{contdata !== null ? Number(contdata.token_sold).toFixed(4) : 0}</span>
                                    <span>{contdata !== null ? contdata.phase_token : 0} </span>
                                </div>
                                <div className="earn_crypto__range slider">
                                    <div className="slide container">
                                        <div className="range-style overflow-hidden position-relative w-100">
                                            <form>

                                                <div className="buy_crypto__form area-group mb-5 mb-md-6">

                                                    <label className="my-5">Amount</label>
                                                    {/* {tokenchoice === 0 ?
                                                        <div className="d-flex align-items-center br2 p-1 rounded-4 bg1-color">
                                                            <input type="text" placeholder="Enter Amount" value={usdt} onChange={(e) => setusdt(e.target.value)} />
                                                        </div> :
                                                        <div className="d-flex align-items-center br2 p-1 rounded-4 bg1-color">
                                                            <input type="text" placeholder="Enter Amount" value={token} onChange={(e) => settoken(e.target.value)} />
                                                        </div>} */}
                                                    <div className="d-flex align-items-center br2 p-1 rounded-4 bg1-color">
                                                        <input type="text" placeholder="Enter Amount" value={tokennew} onChange={handleChange} />
                                                    </div>
                                                </div>
                                                {showReferral && (

                                                    <div className="buy_crypto__form area-group mb-5 mb-md-6">

                                                        <label className="my-5">Referral Address (Optional)</label>
                                                        {/* {tokenchoice === 0 ?
                                                         <div className="d-flex align-items-center br2 p-1 rounded-4 bg1-color">
                                                             <input type="text" placeholder="Enter Amount" value={usdt} onChange={(e) => setusdt(e.target.value)} />
                                                         </div> :
                                                         <div className="d-flex align-items-center br2 p-1 rounded-4 bg1-color">
                                                             <input type="text" placeholder="Enter Amount" value={token} onChange={(e) => settoken(e.target.value)} />
                                                         </div>} */}
                                                        <div className="d-flex align-items-center br2 p-1 rounded-4 bg1-color">
                                                            <input type="text" placeholder="Enter Ref. Address" value={referral} onChange={(e) => setReferral(e.target.value)} />
                                                        </div>
                                                    </div>

                                                )}

                                                <div className='d-flex justify-content-between p-3'>
                                                    <div>
                                                        <label htmlFor="html">USDT</label><br />
                                                        <input type="radio" id="armaDepasdw" name="c_token_depo_daw" defaultChecked={true} onChange={(e) => settokenchoice(0)} />
                                                    </div>
                                                    <div>
                                                        <label htmlFor="html">ARMA</label><br />
                                                        <input type="radio" id="armaDepasdw" name="c_token_depo_daw" onChange={(e) => settokenchoice(1)} />
                                                    </div>
                                                </div>
                                                <div className="d-flex gap-3 justify-content-center flex-wrap mb-5 mb-md-6">
                                                    <div>
                                                        <div className="d-flex align-items-end gap-2">
                                                            <h1 className="fw_500">{tokenchoice === 0 ? usdt : token} </h1>
                                                            <span className="mb-2">{tokenchoice === 0 ? "USDT" : "ARMA"}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                {trdone ? (
                                    <div className='text-center'>
                                        <img
                                            className="border-0"
                                            src="/assets/images/loader.gif"
                                            alt="loading"
                                            height={100}
                                            width={100}
                                        />
                                    </div>
                                ) : (
                                    <a type='button' className="cmn-btn py-3 px-5 px-md-6 d-block" onClick={() => { onDeposit(); switchNetwork(80002); }}>
                                        Buy Sale
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                </div >
            </section >

        </>
    )
}
